<div *ngIf="movies?.length > 0" class="swiper-carousel ">

  <!-- titulo -->
  <h2 class="text-white font_CinematecaBlack fs-4 ml-3 ml-lg-5 mb--30" [ngClass]="{'title-centered-1': felixoliver}">
    {{title}}</h2>

  <swiper [config]="swiperConfig" [(index)]="swiperIndex" [class.noBorderSwiper]="noBorders">
    <div swiperSlide class="movie-poster" *ngFor="let movie of movies">
      <app-ui-poster [movie]="movie" [mostrarInfo]="showInfo"> </app-ui-poster>
    </div>
  </swiper>
</div>